var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search_result",
    on: {
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "symbol_container"
  }, [_c('p', {
    staticClass: "symbol"
  }, [_vm._v(_vm._s(_vm.symbol))])]), _c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(" " + _vm._s(_vm.name) + " "), _c('span', [_vm._v(_vm._s(_vm.idAbbreviated))])]), _c('p', {
    staticClass: "supply"
  }, [_vm._v(" Supply " + _vm._s(_vm.supply.toLocaleString('en-US')) + " " + _vm._s(_vm.symbol) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }